<div class="container">
    <div class="row no-gutters">
        <div class="col">
            <div class="m-auto d-flex align-items-center pb-4">
                <div class="w-25 mr-4">
                    <label for="select-club" translate>SubBoard.LabelClub</label>
                    <bcu-drop-down-cf2 class="w-100 control-height" maxHeigth="450" placeHolder="All" [multiple]="false"
                        [formControl]="searchForm.controls['clubId']" displayKey="shortName" valueKey="id"
                        [options]="clubs" [sortItems]="true" textAlign="left" id="select-club">
                    </bcu-drop-down-cf2>
                </div>

                <div class="w-25 mr-4">
                    <label for="select-club" translate>SubBoard.LabelCategory</label>
                    <bcu-group-drop-down placeHolder="All" [multiple]="true" maxHeigth="450"
                        [formControl]="searchForm.controls['categoryCodes']" [options]="categories" valueKey="code"
                        groupByKey="classTypeName" displayKey="name"></bcu-group-drop-down>
                </div>

                <div class="w-25 mr-4">
                    <label for="select-club" translate>SubBoard.LabelInstructor</label>
                    <bcu-drop-down-cf2 class="w-100 control-height" maxHeigth="450" placeHolder="All" selectAll="true"
                        [multiple]="false" [formControl]="searchForm.controls['instructorId']" displayKey="name"
                        valueKey="id" [options]="instructors" [sortItems]="true" textAlign="left"
                        id="select-instructor">
                    </bcu-drop-down-cf2>
                </div>

                <div class="w-25">
                    <label>&nbsp;</label>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="switch-advanced-mode"
                            [ngModel]="isSimpleMode" (ngModelChange)="viewModeChanged($event)"
                            [ngModelOptions]="{ standalone: true }" data-toggle="collapse"
                            data-target="#row-advanced-search" aria-expanded="false"
                            aria-controls="row-advanced-search">
                        <label class="custom-control-label" for="switch-advanced-mode"
                            translate>SubBoard.LabelSimpleMode</label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters collapse" id="row-advanced-search" #rowAdvancedSearch>
        <div class="col">
            <div class="m-auto d-flex align-items-center pb-4">
                <div class="w-25 mr-4">
                    <label for="picker-date-from" translate>SubBoard.LabelDateFrom</label>
                    <div class="input-group control-date-group">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary control-height" type="button"
                                (click)="dateFromPicker.toggle($event)">
                                <div class="text-center"><span class="ic-calendar-primary"></span></div>
                            </button>
                        </div>
                        <input type="text" class="form-control control-height" placeholder="MM/DD/YYYY"
                            mask="00/00/0000" [validation]="false" [clearIfNotMatch]="false"
                            [dropSpecialCharacters]="false" [formControl]="searchForm.controls['dateFrom']"
                            aria-label="Date-from" aria-describedby="filter-date-from" />
                        <button class="close-icon" type="reset" aria-label="reset" (click)="resetDateFrom()"></button>
                    </div>

                    <bcu-date-select id="classDateFrom" #dateFromPicker [canSelectPastDates]="true"
                        [formControl]="dateFromPickerControl"></bcu-date-select>
                </div>

                <div class="w-25 mr-4">
                    <label for="picker-date-to" translate>SubBoard.LabelDateTo</label>
                    <div class="input-group control-date-group">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary control-height" type="button"
                                (click)="dateToPicker.toggle($event)">
                                <div class="text-center"><span class="ic-calendar-primary"></span></div>
                            </button>
                        </div>
                        <input type="text" class="form-control control-height" placeholder="MM/DD/YYYY"
                            mask="00/00/0000" [validation]="false" [clearIfNotMatch]="false"
                            [dropSpecialCharacters]="false" [formControl]="searchForm.controls['dateTo']"
                            aria-label="Date-to" aria-describedby="filter-date-to" />
                        <button class="close-icon" type="reset" aria-label="reset" (click)="resetDateTo()"></button>
                    </div>
                    <bcu-date-select id="classDateTo" #dateToPicker [canSelectPastDates]="true"
                        [formControl]="dateToPickerControl"></bcu-date-select>
                </div>

                <div class="w-25 mr-4">
                    <label for="select-status" translate>SubBoard.LabelStatus</label>
                    <bcu-drop-down-cf2 class="w-100 control-height" maxHeigth="450" placeHolder="All" selectAll="true"
                        [multiple]="false" [formControl]="searchForm.controls['status']" displayKey="name"
                        valueKey="code" [options]="requestStatuses" [sortItems]="true" textAlign="left"
                        id="select-status">
                    </bcu-drop-down-cf2>
                </div>

                <div class="w-25"> <label>&nbsp;</label> </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col">
            <ng-container *ngIf="!searchForm.controls['advancedMode'].value; else advancedList">
                <div *ngIf="urgentRequests && urgentRequests.length > 0" class="pb-5">
                    <app-sub-board-section-header class="mb-1" [requestCount]="urgentRequests.length" [pending]="false"
                        [headerId]="'SubBoard.Urgent'" [urgent]="true">
                    </app-sub-board-section-header>

                    <div *ngFor="let request of urgentRequests" class="pb-4">
                        <app-substitution-request-list-item [model]="request" [showStatus]="false">
                        </app-substitution-request-list-item>
                    </div>
                </div>

                <div *ngIf="upcomingRequests && upcomingRequests.length > 0">
                    <div class="mb-2">
                        <app-sub-board-section-header [requestCount]="upcomingRequests.length" [pending]="false"
                            [headerId]="'SubBoard.Upcoming'">
                        </app-sub-board-section-header>
                    </div>

                    <div *ngFor="let request of upcomingRequests" class="pb-4">
                        <app-substitution-request-list-item [model]="request" [showStatus]="false">
                        </app-substitution-request-list-item>
                    </div>
                </div>
            </ng-container>

            <ng-template #advancedList>
                <div *ngIf="allRequests.length > 0" class="pb-5">
                    <div *ngFor="let request of allRequests" class="pb-4">
                        <app-substitution-request-list-item [model]="request" [showStatus]="true">
                        </app-substitution-request-list-item>
                    </div>
                </div>
            </ng-template>

            <bcu-no-results *ngIf="subBoardIsEmpty"></bcu-no-results>

        </div>
    </div>

</div>
